import Analytics from '@withlocals/withlocals-analytics';
import LocalizedLink from 'components/LocalizedLink';
import PageContentBlock from 'components/PageContentBlock';
import ExternalLink from 'components/organisms/ExternalLink';
import React from 'react';
import { isCordova } from 'utils/platform';
import { useUser } from '~/authentication/store';

import LiveSupportBadge from './LiveSupportBadge';

const CSS = require('./Support.module.scss');

function Support() {
  const { isHost, isOnboardingHost, isOnboardingHostWebinar } = useUser();

  const onClickHelp = (e) => {
    if (isCordova()) {
      e.preventDefault();
      window.open(e.currentTarget.getAttribute('href'), '_system');
    }
    Analytics.track('Host homepage', 'Click', 'Support help center');
  };
  const onClickEmail = () =>
    Analytics.track('Host homepage', 'Click', 'Support email');
  const onClickPhone = () =>
    Analytics.track('Host homepage', 'Click', 'Support phone');
  const onClickWhatsApp = () =>
    Analytics.track('Host homepage', 'Click', 'Support whatsapp');
  const onClickWhatsAppCommunity = () =>
    Analytics.track('Host homepage', 'Click', 'Support whatsapp community');
  const onClickHostInstagram = () =>
    Analytics.track(
      'Host homepage',
      'Click',
      'Follow host community instagram',
    );

  return (
    <div className={CSS.Support}>
      <PageContentBlock>
        <div>
          <h2 className={CSS.Title}>Support</h2>
          <p className={CSS.SubTitle}>We are here for you.</p>
          <div className={CSS.ItemContainer}>
            <span className={CSS.Emoji} role="img" aria-label="Question">
              ❓&nbsp;
            </span>
            <p className={CSS.Paragraph}>
              Visit the&nbsp;
              <a
                className={CSS.Link}
                href="https://host-support.withlocals.com/hc/en-us"
                rel="noopener noreferrer"
                target="_blank"
                onClick={onClickHelp}
              >
                help center
              </a>
            </p>
          </div>
          <div className={CSS.ItemContainer}>
            <span className={CSS.Emoji} role="img" aria-label="Envelope">
              💌&nbsp;
            </span>
            <p className={CSS.Paragraph}>
              Reach us via email at&nbsp;
              <a
                className={CSS.Link}
                onClick={onClickEmail}
                href="mailto:hosts@withlocals.com"
              >
                hosts@withlocals.com
              </a>
            </p>
          </div>
          <div className={CSS.ItemContainer}>
            <span className={CSS.Emoji} role="img" aria-label="Phone">
              ☎️&nbsp;
            </span>
            <p className={CSS.Paragraph}>
              Having a more urgent issue? Give us a ring&nbsp;
              <a
                className={CSS.Link}
                onClick={onClickPhone}
                href="tel:+31202440076"
              >
                +31 20 2440 076
              </a>
            </p>
          </div>
          <div className={CSS.ItemContainer}>
            <span className={CSS.Emoji} role="img" aria-label="Message">
              💬&nbsp;
            </span>
            <p className={CSS.Paragraph}>
              Or send us a message via WhatsApp on&nbsp;
              <a
                className={CSS.Link}
                onClick={onClickWhatsApp}
                href="whatsapp://send?phone=31202044581"
                target="_blank"
                rel="noopener noreferrer"
              >
                +31 20 204 45 81
              </a>
            </p>
          </div>
          {(isHost || isOnboardingHost || isOnboardingHostWebinar) && (
            <>
              <div className={CSS.ItemContainer}>
                <span
                  className={CSS.Emoji}
                  role="img"
                  aria-label="Whatsapp Community"
                >
                  👉&nbsp;
                </span>
                <p className={CSS.Paragraph}>
                  Join the General Withlocals WhatsApp Community &nbsp;
                  <ExternalLink
                    noAuth
                    className={CSS.Link}
                    onClick={onClickWhatsAppCommunity}
                    url="https://chat.whatsapp.com/CUI9nJdpY7q6YL1f6vrC3m"
                    openInNewTab
                    rel="noopener noreferrer"
                  >
                    here
                  </ExternalLink>
                </p>
              </div>
              <div className={CSS.ItemContainer}>
                <span
                  className={CSS.Emoji}
                  role="img"
                  aria-label="Host Instagram"
                >
                  📸&nbsp;
                </span>
                <p className={CSS.Paragraph}>
                  Follow the Withlocals Host Community on Instagram&nbsp;
                  <ExternalLink
                    noAuth
                    className={CSS.Link}
                    onClick={onClickHostInstagram}
                    url="https://www.instagram.com/forlocalswithlocals/"
                    openInNewTab
                    rel="noopener noreferrer"
                  >
                    this link
                  </ExternalLink>
                </p>
              </div>

              <div className={CSS.ItemContainer}>
                <span className={CSS.Emoji} role="img" aria-label="Thumbs up">
                  👍&nbsp;
                </span>
                <p className={CSS.Paragraph}>
                  Have any feedback for us? Share&nbsp;
                  <LocalizedLink className={CSS.Link} to="/host/feedback/">
                    your feedback
                  </LocalizedLink>
                </p>
              </div>
            </>
          )}
          <LiveSupportBadge />
        </div>
      </PageContentBlock>
    </div>
  );
}

export default Support;
